module.exports = __webpack_public_path__ + "img/new_message_icon.5b51d369.svg";